module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./~/youboralib/src/version.js
// module id = 19
// module chunks = 0